import { Box, Collapse } from "@mui/material";
import { SnackbarProvider as NotistackProvider } from "notistack";
import { useRef } from "react";
import Iconify, {
  type IconifyProps,
} from "@/components/baseComponents/Iconify";
import StyledNotistack, {
  StyledMaterialDesignContent,
} from "./snackbarProvider.styles";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

type SnackbarIconProps = IconifyProps;

const SnackbarIcon = ({ icon }: SnackbarIconProps) => (
  <Box
    component="span"
    sx={{
      mr: "12px",
      display: "flex",
      alignItems: "center",
      color: `common.white`,
    }}
  >
    <Iconify icon={icon} width={24} />
  </Box>
);

const SnackbarProvider = ({ children }: Props) => {
  const notistackRef = useRef<NotistackProvider>(null);

  return (
    <>
      <StyledNotistack />
      <NotistackProvider
        ref={notistackRef}
        dense
        maxSnack={5}
        autoHideDuration={3000}
        TransitionComponent={Collapse}
        variant="success" // Set default variant
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        iconVariant={{
          info: <SnackbarIcon icon="ic:outline-info" />,
          success: <SnackbarIcon icon="ic:baseline-check-circle" />,
          warning: <SnackbarIcon icon="grommet-icons:alert" />,
          error: <SnackbarIcon icon="mdi:error" />,
        }}
        Components={{
          info: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
        }}
      >
        {children}
      </NotistackProvider>
    </>
  );
};

export default SnackbarProvider;
